<div id="register" fxLayout="column">

    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/logoM.png">
            </div>

            <div class="title">{{ 'REGISTER.TITLE' | translate}}</div>

            <form name="registerForm" [formGroup]="registerForm" novalidate>

                
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.EMAIL' | translate}}</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="registerForm.get('email').hasError('required')">
                        {{ 'REGISTER.EMAIL_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="registerForm.get('email').hasError('email')">
                        {{ 'REGISTER.EMAIL_NOT_VALID' | translate}}
                    </mat-error>
                </mat-form-field>
                <!--<button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                (click)="facelogin()" *ngIf="!muestraCamara && !haveFace">
                        AÑADIR FACE LOGIN
                </button>-->
                <div class="logo">
                    <img  width="250px" height="200px" [src]="value"  *ngIf="haveFace">
                </div>
                <button mat-raised-button type="submit" color="red" class="submit-button" aria-label="LOG IN"
                (click)="cancelfacelogin()" *ngIf="haveFace">
                        NO FACE LOGIN
                </button>
                <p>
                    <video #video id="myvideo" class="vid" autoplay  *ngIf="muestraCamara"></video>
                </p>
                <button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                (click)="cancelfacelogin()" *ngIf="muestraCamara">
                        CANCEL
                </button>
                
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PASSWORD' | translate}}</mat-label>
                    <input matInput type="password" formControlName="clave">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{ 'REGISTER.PASSWORD_REQUIRED' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PASSWORD_CONFIRMATION' | translate}}</mat-label>
                    <input matInput type="password" formControlName="passwordConfirm">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('required')">
                        {{ 'REGISTER.PASSWORD_CONFIRMATION_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!registerForm.get('passwordConfirm').hasError('required') &&
                                       registerForm.get('passwordConfirm').hasError('passwordsNotMatching')">
                        {{ 'REGISTER.PASSWORD_CONFIRMATION_MATCH' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.BUSINESS_NAME' | translate}}</mat-label>
                    <input matInput formControlName="razonSocial">
                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                    <mat-error>
                        {{ 'REGISTER.BUSINESS_NAME_REQUIRED' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.VAT_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="cif">
                    <mat-icon matSuffix class="secondary-text">assignment_ind</mat-icon>
                    <mat-error>
                        {{ 'REGISTER.VAT_NUMBER_REQUIRED' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PHONE_1' | translate}}</mat-label>
                    <input matInput formControlName="telefono1">
                    <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                    <!--
                          <mat-error>
                        {{ 'REGISTER.PHONE_1_REQUIRED' | translate}}
                    </mat-error>
                    -->
                  
                </mat-form-field>

                
<!-- 
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.TRADENAME' | translate}}</mat-label>
                    <input matInput formControlName="nombreComercial">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                  
                   
                </mat-form-field>
           
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.BILLING_ADDRESS' | translate}}</mat-label>
                    <input matInput formControlName="direccionFacturacion">
                    <mat-icon matSuffix class="secondary-text">location_on</mat-icon>
                    
                   
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.WEB' | translate}}</mat-label>
                    <input matInput formControlName="web">
                    <mat-icon matSuffix class="secondary-text">http</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PROMOTIONAL_CODE' | translate}}</mat-label>
                    <input matInput formControlName="codigoPromocional">
                    <mat-icon matSuffix class="secondary-text">card_giftcard</mat-icon>
                </mat-form-field>

                <div class="advise" *ngIf="registerForm.getRawValue().codigoPromocional == 'FAI100'">{{ 'REGISTER.PAYMENT_ADVISE' | translate}}</div>

     <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PAYMENT_CARD_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="numeroTarjeta">
                    <mat-icon matSuffix class="secondary-text">credit_card</mat-icon>
                    <mat-error *ngIf="registerForm.get('numeroTarjeta').hasError('required')">
                        {{ 'REGISTER.CARD_NUMBER_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!validarTarjeta(registerForm.get('numeroTarjeta').value)">
                        {{ 'REGISTER.PAYMENT_CARD_NOT_VALID' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PAYMENT_CARD_MONTH' | translate}}</mat-label>
                    <input type="number" max="12" min="1" matInput formControlName="mesTarjeta">
                    <mat-icon matSuffix class="secondary-text">today</mat-icon>
                    <mat-error *ngIf="registerForm.get('mesTarjeta').hasError('required')">
                        {{ 'REGISTER.CARD_MONTH_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!registerForm.get('mesTarjeta').hasError('required') &&
                                       registerForm.get('mesTarjeta').hasError('cardMonthNotValid')">
                        {{ 'REGISTER.PAYMENT_CARD_MONTH_NOT_VALID' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.PAYMENT_CARD_YEAR' | translate}}</mat-label>
                    <input type="number" max="99" min="20" matInput formControlName="anyoTarjeta">
                    <mat-icon matSuffix class="secondary-text">today</mat-icon>
                    <mat-error *ngIf="registerForm.get('anyoTarjeta').hasError('required')">
                        {{ 'REGISTER.CARD_YEAR_REQUIRED' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!registerForm.get('anyoTarjeta').hasError('required') &&
                                       registerForm.get('anyoTarjeta').hasError('cardYearNotValid')">
                        {{ 'REGISTER.PAYMENT_CARD_YEAR_NOT_VALID' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!registerForm.get('anyoTarjeta').hasError('required') &&
                                       registerForm.get('anyoTarjeta').hasError('cardDateNotValid')">
                        {{ 'REGISTER.PAYMENT_CARD_DATE_NOT_VALID' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" >
                    <mat-label>{{ 'REGISTER.PAYMENT_CARD_CVV' | translate}}</mat-label>
                    <input type="number" max="9999" min="1" matInput formControlName="cvvTarjeta">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error *ngIf="registerForm.get('cvvTarjeta').hasError('required')">
                        {{ 'REGISTER.CARD_CVV_REQUIRED' | translate}}
                    </mat-error>
                </mat-form-field>


               
                <div class="contacto">{{ 'REGISTER.CONTACT_DATA' | translate}}</div>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.CONTACT_NAME' | translate}}</mat-label>
                    <input matInput formControlName="contactoNombre">
                    <mat-icon matSuffix class="secondary-text">face</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REGISTER.CONTACT_EMAIL' | translate}}</mat-label>
                    <input matInput formControlName="contactoEmail">
                    <mat-icon matSuffix class="secondary-text">alternate_email</mat-icon>
                 
                       <mat-error *ngIf="registerForm.get('contactoEmail').hasError('email')">
                        {{ 'REGISTER.EMAIL_NOT_VALID' | translate}}
                    </mat-error>  
                   
                   
                </mat-form-field> 

                <div class="terms" fxLayout="row" fxLayoutAlign="center center">
                    <mat-checkbox name="terms" aria-label="I read and accept" formControlName="termsAndConditions"
                        required>
                        <span>{{ 'REGISTER.READ_AND_ACCEPT' | translate}}</span>
                        <a href="assets/pdf/politica-privacidad.pdf"
                            target="_blank">{{ 'REGISTER.TEMRS_AND_CONDITIONS' | translate}}</a>
                    </mat-checkbox>
                </div>-->

                <button mat-raised-button color="accent" class="submit-button" aria-label="CREATE AN ACCOUNT"
                    (click)="addClient()" [disabled]="registerForm.invalid">
                    {{ 'REGISTER.TITLE' | translate}}
                </button> 

            </form>

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">{{ 'REGISTER.HAVE_ACCOUNT' | translate}}</span>
                <a class="link" [routerLink]="'/pages/auth/login'">{{ 'REGISTER.LOGIN' | translate}}</a>
            </div>

        </div>

    </div>

</div>